<template>
    <main class="main-content pt-5">
        <section class="section">
            <div class="content has-text-centered">
                <h3 class="mb-3" v-t="'contact.title'"></h3>
            </div>
            <div class="columns">
                <div class="column is-4">
                    <p><strong>MonVin di Montelvini SRL</strong></p>
                    <address>
                        <p class="address"><a href="https://goo.gl/maps/uEuYKQMiYK12" target="_blank">Via Cal Trevigiana, 51<br>31040 Volpago del Montello (TV)<br>Italy</a></p>
                        <p>tel: <a href="tel: +3904238777">+39 0423 8777</a></p>
                        <p>fax.+39 0423 621303</p>
                        <p>email: <a href="mailto: monvin@monvin.it">monvin@monvin.it</a></p>
                        <p>Our partner in Japan: <a href="http://www.draftwine.co.jp/" target="_blank">www.draftwine.co.jp</a></p>
                    </address>
                </div>
                <div class="column is-8">
                    <iframe class="google-map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2783.1629936496365!2d12.093991315842516!3d45.76792362114593!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47793b32118d18df%3A0x8a6c2242b8e77523!2sMontelvini+S.r.l.!5e0!3m2!1sit!2sit!4v1542010260460" frameborder="0" style="border:0" allowfullscreen></iframe>
                </div>
            </div>
        </section>

        <section class="section" id="newsletter-form">
            <div class="content has-text-centered">
                <h3>Newsletter</h3>
            </div>
            <newsletter-form></newsletter-form>
        </section>

        <section class="section">
            <div class="content has-text-centered">
                <h3 v-t="'contact.form.title'"></h3>
            </div>
            <contact-form></contact-form>
        </section>
    </main>
</template>
<script>
    import ContactForm from './../components/ContactForm';
    import NewsletterForm from './../components/NewsletterForm';
    import {TweenLite} from 'gsap'
    import ScrollToPlugin from 'gsap/ScrollToPlugin'

    export default {
        components: {
            ContactForm,
            NewsletterForm
        },
        mounted() {
            if( this.$route.query.newsletter ) {
                TweenLite.to( window, .5, { scrollTo: { y: '#newsletter-form', offsetY: 90 } } )
            }
        },
        metaInfo() {
            return {
                title: this.$t('seo.contact.title'),
                meta: [
                    {name: 'title', content: this.$t('seo.contact.title')},
                    {name: 'description', content: this.$t('seo.contact.description')}
                ]
            }
        }
    }
</script>